import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseFormComponent } from "../../base-form.component";
import { DeviceEditComponent } from './../device-edit/device-edit.component';

@Component({
    selector: 'update-confirm-form',
    templateUrl: './update-confirm-form.component.html',
    styleUrls: ['./update-confirm-form.component.scss']
})
export class UpdateConfirmFormComponent extends BaseFormComponent implements OnInit {



    private _password: string = "";
    public get password() {
        return this._password
    }
    public set password(v: string) {
        this._password = v;
    }

    constructor(
        public dialogRef: MatDialogRef<DeviceEditComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        super();
    }


    public async ngOnInit() {

    }

    public async confirm() {
        if (this.data == this._password) {
            this.dialogRef.close(true)
        } else {
            this.dialogRef.close(false)
        }

    }

}
